// extracted by mini-css-extract-plugin
module.exports = {"fields":"VehicleBase_fields__2GQU0","block":"VehicleBase_block__3K2Ky"};